import { useAccount } from '@azure/msal-react';
import { Logout, PersonOutline } from '@mui/icons-material';
import { AppBar, Divider, IconButton, Stack, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router';

import AkaLogo from '../../public/assets/images/haufe-akademie-logo-icon.svg';
import { url } from '../url';

export const Header = () => {
  const account = useAccount();

  const navigate = useNavigate();

  if (!account) {
    throw new Error('Unauthorized');
  }

  return (
    <AppBar
      color="inherit"
      position="sticky"
      sx={(theme) => ({
        zIndex: 5,
        height: '69px',
        borderBottom: `1px solid ${theme.palette.border.subtle}`,
        paddingX: 5,
        paddingY: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      })}
    >
      <Stack direction="row" spacing={2} sx={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
        <Stack direction="row" spacing={2}>
          <IconButton sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2 }} component={Link} to={url.root()}>
            <img alt="Haufe Akademie Logo" src={AkaLogo} style={{ height: '21px' }} />
            <Divider orientation="vertical" sx={{ height: '18px' }} />
            <Typography variant="headingXxs" sx={{ textDecoration: 'none' }} color="primary">
              Viva SAP-Adapter
            </Typography>
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={4}>
          <Stack direction="row" alignItems="center">
            <PersonOutline sx={{ mr: '6px' }} />
            <Typography variant="label" sx={{ mr: 2 }}>
              {account.name?.replace(',', '').split(' ').reverse().join(' ')}
            </Typography>
            <IconButton onClick={async () => await navigate(url.auth.logout())}>
              <Logout />
            </IconButton>
          </Stack>
        </Stack>
      </Stack>
    </AppBar>
  );
};
